<template>
    <div>
        <b-card>
            <template slot="header">
                <b-row>
                    <b-col cols="9" sm="7" md="6" lg="6" xl="5"></b-col>
                    <b-col cols="9" sm="7" md="6" lg="6" xl="5">
                        <h3>Lista de Conductores</h3>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col cols="2" sm="3" md="4" lg="4" xl="7">
                    <b-button
                    variant="primary"
                    @click="abrirModalConductor()">
                    Conductor 
                    <i class="fa fa-id-card" aria-hidden="true"></i>
                    <i class="fa fa-plus ml-2" aria-hidden="true"></i>
                    </b-button>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="2">
                    <b-form-group horizontal label="Orden">
                    <b-input-group>
                        <b-form-select v-model="orden" slot="append" @input="listarConductores">
                            <option :value="'asc'">Más Antiguo</option>
                            <option :value="'desc'">Más Reciente</option>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
                </b-col>
                <b-col cols="12" sm="10" md="10" lg="10" xl="2">
                    <b-form-group horizontal label="Mostrar">
                        <b-input-group>
                        <b-form-select v-model="limite" slot="append">
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="1">
                    <b-button
                    v-b-tooltip.hover="'Actualizar'"
                    @click="listarConductores()">
                    <i class="fa fa-sync-alt"></i>
                    </b-button>
                </b-col>
                <b-modal v-model="modalAddConductor" size="xl">
                    <template slot="modal-title">
                        <h3 v-if="!mostrarBotonEdicion">Agregar Conductor <i class="fa fa-id-card fa-lg" aria-hidden="true"></i></h3>
                        <h3 v-else>Editar Conductor <i class="fa fa-id-card fa-lg" aria-hidden="true"></i></h3>
                    </template>
                    <b-row>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-select v-model="tipoDocumento">
                            <option 
                                :value="tipodocumento.tipo" 
                                v-for="tipodocumento in documentoIdentidad" 
                                v-bind:key="tipodocumento.tipo">
                                {{tipodocumento.nombre}}
                            </option>
                        </b-select>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="nroDocumento"
                                 @keydown="handleKeyDown"
                                 @input="mayus()"
                                placeholder="Documento"
                                type="text"
                                maxlength="11">  
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-input-group>
                                <b-form-input
                                    v-model="nombres"
                                    placeholder="Nombres"
                                    type="text"
                                    >
                                </b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="apellidos"
                                placeholder="Apellidos"
                                type="text">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input 
                                v-model="direccion"
                                placeholder="Dirección"
                                type="text">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <datepicker
                                placeholder="Fecha Nacimiento"
                                v-model="fechaNacimiento"
                                :bootstrap-styling="true"          
                                :language="es" 
                                :format="customFormatter">
                            </datepicker>      
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                           <b-form-input
                                v-model="codigo"
                                placeholder="Código / Alias"
                                type="text"
                                maxlength="15">
                            </b-form-input>
                        </b-col>
                         <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="nroLicencia"
                                placeholder="Nro Licencia"
                                 @keydown="handleKeyDown"
                                 @input="mayus()"
                                type="text">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">       
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="catLicencia"
                                 @keydown="handleKeyDown"
                                 @input="mayus()"
                                placeholder="Categoria Licencia"
                                type="text">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                             <datepicker
                                placeholder="Vencimiento Licencia"
                                v-model="vencLicencia"
                                :bootstrap-styling="true"          
                                :language="es" 
                                :format="customFormatter">
                            </datepicker>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="6">
                            <b-button v-if="!mostrarBotonEdicion"
                                :disabled="validarConductor()"
                                style="width:100%"
                                variant="primary"
                                @click="AddConductor()">
                                Agregar
                                
                            </b-button>
                            <!-- <b-button v-else
                                :disabled="validarConductor()"
                                style="width:100%"
                                variant="warning"
                                @click="enviarEdicionConductor()">
                                Editar
                            </b-button> -->
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                         <b-col cols="12" sm="8" md="6" lg="6" xl="6">
                            <b-form-textarea
                            v-model="observaciones"
                            placeholder="Ingresar Observaciones..."
                            maxlength="100"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                         </b-col>
                    </b-row>
                    <br>
                    <!-- ASOCIAR UN VEHICULO -->
                    <template v-if="mostrarBotonEdicion">
                    <b-row>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="6">
                            <h3>Vehículo Asociado al Conductor
                                <b-button 
                                    class="ml-1"
                                    v-b-tooltip.hover title="En la lista se mostrará el vehículo asociado al conductor"
                                    size="sm"
                                    variant="primary">
                                    <i class="fa fa-question-circle fa-lg"></i>
                                </b-button>
                                <template v-if="mostrarListaDeVehiculos">
                                    <b-button
                                        class="ml-3"
                                        v-b-tooltip.hover="'Ocultar'"
                                        variant="primary"
                                        size="sm"
                                        @click="ocultarLista()">
                                        <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                    </b-button>
                                </template>
                                <template v-else>
                                    <b-button 
                                        class="ml-3"
                                        v-b-tooltip.hover="'Mostrar'"
                                        variant="primary"
                                        size="sm"
                                        @click="mostrarLista()">
                                        <i class="fa fa-arrow-down" aria-hidden="true"></i>
                                    </b-button>
                                </template>
                            </h3>
                        </b-col>
                    </b-row>
                    <template v-if="mostrarListaDeVehiculos">
                    <b-table v-if="vehiculoDelConductor.length >0"
                        small
                        responsive
                        outlined
                        :items="vehiculoDelConductor"
                        :fields="vehiculoDelConductor_lista"
                        >
                        <template slot="tipoVehiculo" slot-scope="row">
                           {{row.item.vehicle.tipoVehiculo}}
                        </template>
                          <template slot="propiedad" slot-scope="row">
                           {{row.item.vehicle.propiedad}}
                        </template>
                        <template slot="codigo" slot-scope="row">
                           {{row.item.vehicle.codigo}}
                        </template>
                        <template slot="placa" slot-scope="row">
                           {{row.item.vehicle.placa}}
                        </template>
                        <template slot="pesoBruto" slot-scope="row">
                           {{row.item.vehicle.pesoBruto}}
                        </template>
                        <template slot="CategoriaMTC" slot-scope="row">
                           {{row.item.vehicle.CategoriaMTC}}
                        </template>
                        <template slot="nroCirculacionMTC" slot-scope="row">
                           {{row.item.vehicle.nroCirculacionMTC}}
                        </template>
                        <template slot="observaciones" slot-scope="row">
                           {{row.item.vehicle.observaciones}}
                        </template>
                    </b-table>
                    <b-jumbotron v-else class="text-center">
                        No hay ningún vehículo asociado.
                    </b-jumbotron>
                     <!-- FIN ASOCIAR UN VEHICULO -->
                    <br>
                     <!-- LISTA DE VEHICULOS PARA ASOCIAR AL CONDUCTOR -->
                     <b-row>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="11">
                            <h3>Asociar un vehículo de la lista  
                                <b-button 
                                    class="ml-1"
                                    v-b-tooltip.hover title="Seleccionar el vehículo que desea asociar al conductor, si ya existe un vehiculo asociado, una línea verde se pintará."
                                    size="sm"
                                    variant="primary">
                                    <i class="fa fa-question-circle fa-lg"></i>
                                </b-button> 
                            </h3>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="1">
                            <b-button 
                                class="ml-1"
                                v-b-tooltip.hover title="Seleccionar 1 casillero y hacer Clic en Editar para asociar 1 vehículo"
                                size="sm"
                                variant="primary">
                                 <i class="fa fa-question-circle fa-lg"></i>
                            </b-button>
                        </b-col>
                     </b-row>
                     <template v-if="mostrarTablaVehiculos">
                        <div class="text-center">
                            <h2><i class="fa fa-spin fa-spinner"></i> Cargando...</h2>
                        </div>
                    </template>
                    <template v-else>
                     <b-table
                        small
                        hover
                        responsive
                        outlined
                        :tbody-tr-class="rowClass"
                        :items="vehiculos"
                        :fields="vehiculos_lista">
                        <template slot="seleccionar" slot-scope="data">
                              <div class="text-center">
                                <b-checkbox
                                    v-model="data.item.selected"
                                    @change="seleccionarVehiculo(data.item)">
                                </b-checkbox>
                              </div>
                        </template>
                     </b-table>
                     </template>
                     <b-row>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <p>Mostrando del {{desdeVehiculos}} al {{hastaVehiculos}} de un total de {{totalVehiculos}} registros</p>
                            </b-col>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <div class="float-right">
                                <b-pagination
                                    :total-rows="totalVehiculos"
                                    v-model="paginaActualVehiculos"
                                    @input="listarVehiculos"
                                    :per-page="limiteVehiculos"
                                ></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                     </template>
                     <!-- FIN LISTA DE VEHICULOS PARA ASOCIAR AL CONDUCTOR -->
                     </template>
                    <template slot="modal-footer">
                        <b-button v-if="mostrarBotonEdicion"
                            :disabled="validarConductor()"
                            style="width:100%"
                            variant="warning"
                            @click="enviarEdicionConductor()">
                            Editar
                        </b-button>
                    </template>
                    
                </b-modal>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="9" sm="7" md="6" lg="6" xl="12">
                    <template v-if="mostrarTabla">
                        <div class="text-center">
                            <h2><i class="fa fa-spin fa-spinner"></i> Cargando...</h2>
                        </div>
                    </template>
                    <template v-else>
                        <b-table
                            striped
                            bordered
                            small
                            hover
                            responsive
                            outlined
                            :per-page="limite"
                            :items="conductores"
                            :fields="conductores_lista">
                            <!-- <template slot="index" slot-scope="row"><b>{{ row.index+1 }}</b></template> -->
                            <template slot="tipoDocumento" slot-scope="row">
                                <div v-if="row.item.tipoDocumento == 6">RUC</div>
                                <div v-if="row.item.tipoDocumento == 1">DNI</div>
                                <div v-if="row.item.tipoDocumento == 4">Carnet Extranjeria</div>
                                <div v-if="row.item.tipoDocumento == 7">Pasaporte</div>
                            </template>
                            <template slot="eliminarEditar" slot-scope="row">
                              <b-button-group>
                                  <b-button 
                                    v-b-tooltip.hover="'Editar'"
                                    size="sm"
                                    variant="warning"
                                    @click="capturaInfoEdicionConductor(row.item)">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                    </b-button>
                                    <b-button
                                    v-b-tooltip.hover="'Eliminar'"
                                    size="sm"
                                    variant="danger"
                                    @click="eliminarConductor(row.item)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                    </b-button>
                              </b-button-group>
                            </template>
                        </b-table>
                        <b-row>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                            </b-col>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <div class="float-right">
                                <b-pagination
                                    :total-rows="total"
                                    v-model="paginaActual"
                                    @input="listarConductores"
                                    :per-page="limite"
                                ></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>       
       </b-card>
       <vue-snotify></vue-snotify>
    </div>
</template>
<script>
import axios from "axios";
import { DocumentosIdentidad } from '@/shared/utils'
import {es} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
export default {
    name:  "Negocios_Conductor",
    components:{
        Datepicker
    },
    data() {
        return {
            codigo:"",
            nroDocumento:'',
            nombres:'',
            apellidos:'',
            direccion:'',
            tipoDocumento:6,
            documentoIdentidad:DocumentosIdentidad,
            fechaNacimiento:'',
            es:es,
            nroLicencia:'',
            catLicencia:'',
            vencLicencia:'',
            observaciones:'',
            mostrarBotonEdicion:false,
            modalAddConductor:false,
            mostrarTabla: true,
            mostrarTablaVehiculos: true,   
            conductores:[],
            conductores_lista:[
               { key: "tipoDocumento", label: "Tipo Doc."},
               { key: "nroDocumento", label: "Doc."},
               { key: "codigo", label: "Código"},
               { key: "nombres", label: "Nombres"},
               { key: "apellidos", label: "Apellidos"},
               { key: "direccion", label: "Dirección"},
               { key: "fechaNacimiento", label: "Fec. Nacimiento"},
               { key: "nroLicencia", label: "Nro. Licencia"},
               { key: "catLicencia", label: "Cat. Licencia"},
               { key: "vencLicencia", label: "Vencimiento Licencia"},
               { key: "observaciones", label: "Observaciones"},
               { key: "eliminarEditar", label: "Acciones"},
            ],
            idConductor:'',
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            paginaActual: 1,
            limite:10,
            totalVehiculos: 0.0,
            desdeVehiculos: 0.0,
            hastaVehiculos: 0.0,
            paginaActualVehiculos: 1,
            limiteVehiculos:8,
            vehiculoDelConductor:[],
            vehiculoDelConductor_lista:[
               { key: "tipoVehiculo", label: "Tipo Vehículo"},
               { key: "propiedad", label: "Propiedad"},
               { key: "codigo", label: "Código"},
               { key: "placa", label: "Placa"},
               { key: "pesoBruto", label: "Peso Bruto"},
               { key: "CategoriaMTC", label: "Categoria MTC"},
               { key: "nroCirculacionMTC", label: "Nro. Circulacion MTC"},
               { key: "observaciones", label: "Observacion"},

            ],
            vehiculos:[],
            vehiculos_lista:[
               { key: "tipoVehiculo", label: "Tipo Vehículo"},
               { key: "propiedad", label: "Propiedad"},
               { key: "codigo", label: "Código"},
               { key: "placa", label: "Placa"},
               { key: "pesoBruto", label: "Peso Bruto"},
               { key: "CategoriaMTC", label: "Categoria MTC"},
               { key: "nroCirculacionMTC", label: "Nro. Circulacion MTC"},
               { key: "observaciones", label: "Observacion"},
               { key: "seleccionar", label: "Seleccionar"},
            ],
            idAsociado:'',
            idNuevoAsociado:'',
            mostrarListaDeVehiculos:false,
            orden: "desc",
        }
    },
    mounted(){
        this.listarConductores();
        this.listarVehiculos();
    },
    watch:{
        nroDocumento(){
            if(this.nroDocumento.length == 8){
                this.tipoDocumento = 1
            }else if(this.nroDocumento.length == 11){
                this.tipoDocumento = 6
            }
            if(this.nroDocumento.length < 2){
                this.nombres = '';
                this.apellidos = '';
            }
            if(this.tipoDocumento == 6){
                if(this.nroDocumento.charAt(0) == "2"){
                   setTimeout(() => this.nroDocumento = '', 200);   
                }
            }
        },
        fechaNacimiento(date){
            this.fechaNacimiento = this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        vencLicencia(date){
           this.vencLicencia = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');  
        }
    },
    methods:{
        customFormatter(date) {
            return this.$moment(date).format('YYYY/MM/DD HH:mm:ss')
        },

        abrirModalConductor(){
            this.modalAddConductor = true;
            this.mostrarBotonEdicion = false;
            this.limpiarDatos();
        },
        validarConductor(){
            if(this.nroDocumento !='' &&
               this.codigo !='' && 
               this.nombres !='' && 
               this.apellidos !='' &&
               this.direccion !='' &&
               this.fechaNacimiento !='' &&
               this.nroLicencia !='' &&
               this.catLicencia !='' &&
               this.vencLicencia !=''){
                return false;
            }else{
                return true;
            }
        },
        AddConductor(){
            let send = {}
            send.token = this.$store.getters.userToken,
            send.tipoDocumento = this.tipoDocumento,
            send.nroDocumento = this.nroDocumento,
            send.codigo = this.codigo,
            send.nombres = this.nombres,
            send.apellidos = this.apellidos,
            send.direccion = this.direccion,
            send.fechaNacimiento = this.fechaNacimiento,
            send.nroLicencia = this.nroLicencia,
            send.catLicencia = this.catLicencia,
            send.vencLicencia = this.vencLicencia,
            send.observaciones = this.observaciones;

            axios.post(process.env.VUE_APP_API_URL + "conductor/crear",send)
            .then(response =>(
                 this.$snotify.success(response.data.msg, "Exito"),
                 this.limpiarDatos(),
                 this.modalAddConductor = false,
                 this.listarConductores()
            ))
            .catch(error =>(
                this.$snotify.warning(error.response.data.msg, "Error")
            ))
        },
        limpiarDatos(){
            this.tipoDocumento = 6, 
            this.nroDocumento = '',
            this.codigo = '',
            this.nombres = '',
            this.apellidos = '',
            this.direccion = '',
            this.fechaNacimiento = '',
            this.nroLicencia = '',
            this.catLicencia = '',
            this.vencLicencia = '',
            this.observaciones = ''
        },
        listarConductores(){
            this.mostrarTabla = true;
            axios.post(process.env.VUE_APP_API_URL + "conductor/listar",{
                token:this.$store.getters.userToken,
                page: this.paginaActual,
                limit: this.limite,
                order: this.orden
            })
            .then(response =>(
                this.conductores = response.data.data,
                this.mostrarTabla = false,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        capturaInfoEdicionConductor(item){
            this.vehiculoDelConductor = [];
            this.idAsociado = '';
            if(item.vehicle !=null){
                this.vehiculoDelConductor.push(item)
                this.idAsociado = this.vehiculoDelConductor[0].vehicle.idVehiculo
            }

            this.idConductor = item.idConductor
            this.modalAddConductor = true;
            this.tipoDocumento = item.tipoDocumento, 
            this.nroDocumento = item.nroDocumento,
            this.codigo = item.codigo,
            this.nombres = item.nombres,
            this.apellidos = item.apellidos,
            this.direccion = item.direccion,
            this.fechaNacimiento = item.fechaNacimiento,
            this.nroLicencia = item.nroLicencia,
            this.catLicencia = item.catLicencia,
            this.vencLicencia = item.vencLicencia,
            this.observaciones = item.observaciones
            this.mostrarBotonEdicion = true;
        },
        enviarEdicionConductor(){
            let nuevaInfo ={}
            nuevaInfo.token = this.$store.getters.userToken,
            nuevaInfo.idConductor = this.idConductor,
            nuevaInfo.tipoDocumento = this.tipoDocumento,
            nuevaInfo.nroDocumento = this.nroDocumento, 
            nuevaInfo.codigo = this.codigo,
            nuevaInfo.nombres = this.nombres,
            nuevaInfo.apellidos = this.apellidos,
            nuevaInfo.direccion = this.direccion,
            nuevaInfo.fechaNacimiento = this.fechaNacimiento,
            nuevaInfo.nroLicencia = this.nroLicencia,
            nuevaInfo.catLicencia = this.catLicencia,
            nuevaInfo.vencLicencia = this.vencLicencia,
            nuevaInfo.observaciones = this.observaciones,
            nuevaInfo.idVehiculo = this.idNuevoAsociado,

            axios.post(process.env.VUE_APP_API_URL + "conductor/actualizar",nuevaInfo)
            .then(response =>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.modalAddConductor = false,
                this.mostrarBotonEdicion = false,
                this.listarConductores(),
                this.listarVehiculos()
            ))
            .catch(error=>(
                console.log(error.response.data)
            ))
        },
        eliminarConductor(item){
            this.$swal({
            title: 'Eliminar Vehículo',
            text: '¿Seguro que desea eliminar el Vehículo?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
            }).then((willDelete) => {
            if(willDelete){
                axios.post(process.env.VUE_APP_API_URL + "conductor/borrar",{
                    token: this.$store.getters.userToken,
                    idConductor: item.idConductor
                })
                .then(response =>(
                    this.$snotify.success(response.data.msg, "Exito"),
                    this.listarConductores()
                ))
                .catch(error=>(
                    console.log(error.response.data)
                ))  
            }
            })
        },
        listarVehiculos(){
            this.mostrarTablaVehiculos = true;
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
                page: this.paginaActualVehiculos,
                limit: this.limiteVehiculos,
                order:"desc"
            })
            .then(response =>(
                this.vehiculos = response.data.data,
                this.mostrarTablaVehiculos = false,
                this.totalVehiculos = response.data.total,
                this.desdeVehiculos = response.data.from,
                this.hastaVehiculos = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.idVehiculo == this.idAsociado) {
                return 'table-success';
            }
        },

        seleccionarVehiculo(selectedItem) {
            this.vehiculos.forEach(item => {
                if (item.selected !== selectedItem.selected) {
                    item.selected = false;
                }
            });
            console.log(selectedItem)
            this.idNuevoAsociado = selectedItem.idVehiculo
        },
        ocultarLista(){
            this.mostrarListaDeVehiculos = false
        },
        mostrarLista(){
            this.mostrarListaDeVehiculos = true
        },
        mayus(){
            this.nroDocumento = this.nroDocumento.toUpperCase();
            this.nroLicencia = this.nroLicencia.toUpperCase();
            this.catLicencia = this.catLicencia.toUpperCase();
        },
        handleKeyDown(event) {
             // Expresión regular que identifica los caracteres especiales
            const regex = /^[a-zA-Z0-9]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        }
    }

}
</script>
<style scoped>

</style>